import { Editor } from '@tiptap/core';

import { tiptapJsonToMarkdown } from './tiptapJsonToMarkdown';

export const getTiptapMarkdownContentFromEditor = (
  editor?: Editor | null,
): string => {
  const content = editor?.getJSON();
  if (!content) {
    return '';
  }

  const markdown = tiptapJsonToMarkdown({
    jsonContent: content,
  });

  if (!markdown.ok) {
    return '';
  }

  return markdown.result ?? '';
};
